<footer class="page-footer page-footer--countries">
  <div class="o-wrapper">
    <h4 class="page-footer_country-heading">{{'COUNTRY-SELECTION.DontSeeCountry' | translate}}</h4>
    <p class="page-footer_country-text">{{'COUNTRY-SELECTION.CheckBackSoon' | translate}}</p>
  </div>
</footer>